import { Flex } from "@chakra-ui/react";
import "./NavigatingLoadIndicator.css";
import { useLoading } from "@/services/useLoading";

export function NavigatingLoadIndicator() {
	const [isLoading] = useLoading();
	if (!isLoading) {
		return null;
	}

	const height = 3;

	return (
		<Flex position="fixed" top={0} left={0} right={0} width="100vw" height={`${height}px`} bgColor="shade.100" zIndex={20000}>
			<Flex width={0} height={`${height}px`} bgColor="brand.primaryAccent" animation="navigatingLoadIndicator 10s" />
		</Flex>
	);
}
